import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { Market } from 'src/app/models/market';

@Component({
  selector: 'app-positions',
  templateUrl: './positions.component.html',
  styleUrls: ['./positions.component.scss']
})
export class PositionsComponent implements OnInit, OnChanges {
  @Input() positions: any[] = [];
  @Input() closable = true;
  @Input() isOpenInterest = false;
  @Input() markets: Market[] = [];
  @Output() close = new EventEmitter();

  groupedPositions: any[] = [];

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges() {
    const map = new Map();
    for (let position of this.positions || []) {
      if (!map.has(position.marketName)) {
        map.set(position.marketName, []);
      }
      map.get(position.marketName).push(position);
    }

    this.groupedPositions = this.markets.map((market) => {
      const positions: any[] = map.get(market.name) || [];
      return {
        market,
        positions: positions.sort((a, b) => a.strike - b.strike).sort((a, b) => a.expiry - b.expiry)
      }
    });
  }

  get cols() {
    if (this.isOpenInterest) {
      return 3;
    } else {
      return this.closable ? 8 : 7;
    }
  }

  onClose(market: Market, position: any) {
    this.close.emit({ market, position });
  }
}
